import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { MerchantProcessor } from './merchantProcessor';

@Injectable({
  providedIn: 'root',
})
export class MerchantProcessorService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(private api: GatewayAPIService) {}

  //async createMerchantProcessor(proc: Partial<MerchantProcessor>): Promise<any> {
  //    return (await this.addMerchantProcessor(proc, "processor"));
  //}

  public async addMerchantProcessor(
    p: Partial<MerchantProcessor>,
  ): Promise<string> {
    return this.post(p);
  }

  public async updateMerchantProcessor(
    proc: Partial<MerchantProcessor>,
  ): Promise<any> {
    return this.patch(proc);
  }

  private post(data: any): Promise<string> {
    return this.api.apiCallSane(
      '/merchant/processor',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      data,
      this.options,
    );
  }

  private patch(data: any): Promise<any> {
    return this.api.apiCallSane(
      '/merchant/processor',
      'PATCH',
      this.api.getDefaultHeaders(),
      null,
      { data: data },
      this.options,
    );
  }
}
